/**
 * Palette de couleurs de l'application
 */

export const COLORS = {
  // Couleurs principales
  PRIMARY: "#26A69A",
  PRIMARY_DARK: "#00897B",

  // Couleurs d'alerte
  ORANGE: "#F97316",
  ORANGE_ALT: "#ffa726",
  CYAN: "cyan",

  // Couleurs de fond
  CARD_BACKGROUND: "rgba(40, 50, 45, 0.9)",
  CARD_BACKGROUND_DARK: "rgba(0,0,0,0.2)",
  CARD_BORDER: "rgba(255,255,255,0.08)",
  CARD_BORDER_LIGHT: "rgba(255,255,255,0.05)",

  // Couleurs de texte
  TEXT_SECONDARY: "text.secondary",
  TEXT_DISABLED: "text.disabled",

  // Couleurs spécifiques aux types de devices
  WATER: "#26A69A",
  ELECTRICITY: "#ffa726",
  TEMPERATURE: "#26A69A",
  HUMIDITY: "cyan",
  CO2: "orange",
  TRV: "#F97316",
};

export const ALERT_COLORS = {
  GREEN: "green",
  YELLOW: "yellow",
  RED: "red",
};

export default COLORS;
